import { SEND_FEEDBACK, SendFeedbackAction, Feedback } from './types'

export const sendFeedback = (feedback: Feedback): SendFeedbackAction => {
  return {
    type: SEND_FEEDBACK,
    payload: feedback,
  }
}
